(function () {
  'use strict';

  function init() {
    const form = document.getElementById('kcalFormV2');
    if (!form) return;

    const gender = document.getElementById('gender');
    const age = document.getElementById('age');
    const height = document.getElementById('height');
    const weight = document.getElementById('weight');
    const activity = document.getElementById('activity');
    const goal = document.getElementById('goal');

    const btn = document.getElementById('calcBtnV2');
    const resultWrap = document.getElementById('kcalResultV2');
    const kcalOut = document.getElementById('kcalOut');
    const kcalRange = document.getElementById('kcalRange');
    const kcalRangeWrapper = document.getElementById('kcalRangeWrapper');
    const editBtn = document.getElementById('kcalEditBtn');
    const headerInfo = document.getElementById('kcalHeaderInfo');

    const proteinOut = document.getElementById('proteinOut');
    const carbOut = document.getElementById('carbOut');
    const fatOut = document.getElementById('fatOut');

    if (
      !gender ||
      !age ||
      !height ||
      !weight ||
      !activity ||
      !goal ||
      !btn ||
      !resultWrap ||
      !kcalOut
    ) {
      return;
    }

    function num(el) {
      const n = Number(el.value);
      return Number.isFinite(n) ? n : 0;
    }

    function round(value) {
      return Math.round(value * 100) / 100;
    }

    function formatIntDE(value) {
      return Math.round(value).toLocaleString('de-DE');
    }

    function valid() {
      if (!gender.value) return false;
      if (!activity.value) return false;
      if (!goal.value) return false;

      const a = num(age);
      const h = num(height);
      const w = num(weight);

      if (a <= 0 || h <= 0 || w <= 0) return false;
      return true;
    }

    function setButtonState() {
      const ok = valid();
      btn.disabled = !ok;
      btn.classList.toggle('is-active', ok);
    }

    function calculateLikeOldKcalAndCurrentMacros(g, wKg, hCm, aYears, pal, goalVal) {
      const isMale = g === 'man' || g === 'm' || g === 'male';

      let basic1;
      let basic2;

      if (isMale) {
        basic1 = 10 * wKg + 6.25 * hCm - 5 * aYears + 5;
        basic2 = 88.362 + 13.397 * wKg + 4.799 * hCm - 5.677 * aYears;
      } else {
        basic1 = 10 * wKg + 6.25 * hCm - 5 * aYears - 161;
        basic2 = 447.593 + 9.247 * wKg + 3.098 * hCm - 4.33 * aYears;
      }

      const basicAverage = (basic1 + basic2) / 2;

      const kcalLow = basic1 * pal - 500;
      const kcalMid = basicAverage * pal;
      const kcalHigh = basic2 * pal + 500;

      let targetKcal;
      let calorieIntakeRange;

      if (goalVal === 'deficit') {
        targetKcal = kcalLow;
        calorieIntakeRange = [round(kcalLow), round(kcalMid)];
      } else if (goalVal === 'surplus') {
        targetKcal = kcalHigh;
        calorieIntakeRange = [round(kcalMid), round(kcalHigh)];
      } else {
        targetKcal = kcalMid;
        calorieIntakeRange = [round(kcalMid), round(kcalMid)];
      }

      let proteinIntake;
      let fatIntake;

      if (isMale) {
        proteinIntake = (hCm - 80) * 2;
        fatIntake = (targetKcal * 0.25) / 9;
      } else {
        proteinIntake = (hCm - 105) * 2;
        fatIntake = (targetKcal * 0.3) / 9;
      }

      const carbohydrates = (targetKcal - proteinIntake * 4 - fatIntake * 9) / 4;

      return {
        calorieIntake: round(targetKcal),
        calorieIntakeRange: calorieIntakeRange,
        proteinIntake: round(proteinIntake),
        fatIntake: round(fatIntake),
        carbohydrates: round(carbohydrates)
      };
    }

    function setResults(results) {
      kcalOut.textContent = formatIntDE(results.calorieIntake);

      if (kcalRange && kcalRangeWrapper) {
        if (results.calorieIntakeRange[0] !== results.calorieIntakeRange[1]) {
          kcalRange.textContent = `Spanne: ${formatIntDE(results.calorieIntakeRange[0])} bis ${formatIntDE(results.calorieIntakeRange[1])} kcal`;
          kcalRangeWrapper.style.display = 'block';
        } else {
          kcalRange.textContent = '';
          kcalRangeWrapper.style.display = 'none';
        }
      }

      if (proteinOut) {
        proteinOut.textContent = formatIntDE(results.proteinIntake).replace(/\./g, '');
      }

      if (carbOut) {
        carbOut.textContent = formatIntDE(results.carbohydrates).replace(/\./g, '');
      }

      if (fatOut) {
        fatOut.textContent = formatIntDE(results.fatIntake).replace(/\./g, '');
      }

      form.classList.add('kcal-hidden');
      if (headerInfo) headerInfo.classList.add('kcal-hidden');
      resultWrap.classList.remove('kcal-hidden');
      resultWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function calculate() {
      if (!valid()) return;

      const g = gender.value;
      const a = num(age);
      const h = num(height);
      const w = num(weight);
      const pal = Number(activity.value);
      const goalVal = goal.value;

      const results = calculateLikeOldKcalAndCurrentMacros(g, w, h, a, pal, goalVal);
      setResults(results);
    }

    [gender, activity, goal, age, height, weight].forEach((el) => {
      if (!el) return;
      el.addEventListener('input', setButtonState);
      el.addEventListener('change', setButtonState);
    });

    [age, height, weight].forEach((el) => {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (!btn.disabled) calculate();
        }
      });
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      calculate();
    });

    if (editBtn) {
      editBtn.addEventListener('click', function (e) {
        e.preventDefault();
        resultWrap.classList.add('kcal-hidden');
        form.classList.remove('kcal-hidden');
        if (headerInfo) headerInfo.classList.remove('kcal-hidden');
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    setButtonState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
